<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="iconClass"
    :style="iconStyle"
  >
    <path
      d="M5 15C5 11.134 8.02208 8 11.75 8H12.25C15.9779 8 19 11.134 19 15C19 18.866 15.9779 22 12.25 22H11.75C8.02208 22 5 18.866 5 15Z"
      :stroke="strokeColor"
      stroke-width="1.5"
    />
    <!-- Dynamic number display -->
    <text
      v-if="badgeNumber !== null && badgeNumber !== undefined"
      x="12"
      y="14.5"
      :fill="strokeColor"
      font-size="10.5"
      font-weight="700"
      text-anchor="middle"
      dominant-baseline="central"
      font-family="system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
      style="letter-spacing: 0"
    >
      {{ badgeNumber }}
    </text>
    <!-- Original "2" path - hidden when badgeNumber is provided -->
    <path
      v-else
      d="M10.5 13.1179C10.5804 12.3326 11.1076 12 11.6576 12H12.3239C12.8738 12 13.401 12.3326 13.4814 13.1179C13.5063 13.3608 13.5063 13.6392 13.4814 13.8821C13.4325 14.3602 12.8543 14.9086 12.8543 14.9086L12 15.5C12 15.5 10.5 16.5 10.5 17.5C10.5 18.0394 10.9373 18 11.4766 18H13.4814"
      :stroke="strokeColor"
      stroke-width="1.3"
      stroke-linecap="round"
    />
    <path
      d="M13.5601 2L11 7.89783M18 2L15.1786 8.5"
      :stroke="strokeColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M10.4399 2L12 5.59405M6 2L8.82144 8.5"
      :stroke="strokeColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>

<script setup lang="ts">
interface Props {
  badgeNumber?: number | null;
  color?: string | null;
  size?: string;
}

const props = withDefaults(defineProps<Props>(), {
  badgeNumber: null,
  color: null,
  size: '24px',
});

const strokeColor = computed(() => props.color || '#141B34');

const iconClass = computed(() => {
  return props.size ? `w-[${props.size}] h-[${props.size}]` : '';
});

const iconStyle = computed(() => {
  return {
    width: props.size,
    height: props.size,
  };
});
</script>
